<template>
  <div>
    <div style="position: absolute; margin-top: 300px; margin-left: 210px">
      <v-progress-circular
        size="80"
        indeterminate
        color="gray"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { nonSaveCookie } from "../store/cookie";

export default {
  data() {
    return {
      code: "",
    };
  },
  async created() {
    this.code = this.$route.params.code;

    const token_res = await axios.post(
      `${process.env.VUE_APP_CONNECT}/users/works-token`,
      { code: this.code },
      { credentials: true }
    );

    const res = await axios.post(
      `${process.env.VUE_APP_CONNECT}/users/token/works`,
      {
        code: "",
        token: token_res.data.data,
      },
      { credentials: true }
    );

    sessionStorage.setItem("info2", res.data.data);
    nonSaveCookie("info2", res.data.data);

    window.dispatchEvent(
      new CustomEvent("whalelogincomplete", {
        detail: true,
      })
    );
  },
};
</script>

<style>
</style>